export var defaultProps = {
    className: 'success',
    style: {},
    image: '',
    status: 'success',
    title: '',
    subTitle: '',
    extra: null,
};
